import endPoints from "services/endPoints";
import { showToastAction } from "store/slices/commonSlice";
import { uploadDocuments } from "./ProjectActions";
import postApi from "services/postApi";
import getApi from "services/getApi";
import { set } from "store";
import { handleFormatDate } from "utils/common";
import { setContractDetails } from "store/slices/contractSlice";
import putApi from "services/putApi";

export const createContractAction =
  (payload, setLoading, dispatch, onRes) => async () => {
    setLoading(true);

    try {
      const res = await postApi(endPoints.CREATE_CONTRACT, payload);

      if (res.success) {
        const responseData = {
          ...res.data,
        };
        dispatch(showToastAction({ type: "success", detail: res?.message }));

        // Call the onRes callback with the response data
        if (onRes) {
          onRes({ success: true, data: responseData });
        }
      } else {
        dispatch(showToastAction({ type: "error", detail: res?.message }));
      }
    } catch (error) {
      console.error("Error creating contract:", error);
      dispatch(
        showToastAction({
          type: "error",
          detail: "An unexpected error occurred.",
        })
      );
    } finally {
      // Stop loading regardless of success or failure
      setLoading(false);
    }
  };

export const GetContractDetailsActon = (id, dispatch, onRes) => async () => {
  const res = await getApi(endPoints.CONTRACT_DETAILS + `/${id}`);
  if (res.success) {
    dispatch(setContractDetails(res.data));
    onRes && onRes(res?.data);
  } else {
    dispatch(
      showToastAction({
        type: "success",
        detail: res?.message,
      })
    );
  }
};

export const GetContractListAction =
  (rows, page, search, setIsSearch, dispatch, onRes) => async () => {
    try {
      const res = await getApi(
        endPoints.CONTRACT_LIST +
          `?limit=${rows}&page=${page}&searchKeys=["agreementName","agreementType"]&searchString=${
            search || ""
          }`
      );

      if (res?.success) {
        const result = {
          list: res?.data?.contracts,
          count: res?.data?.counts?.total || 0,
          statusCounts: res?.data?.counts,
        };

        onRes?.(result);
      } else {
        dispatch(
          showToastAction({
            type: "error",
          })
        );
      }
    } catch (error) {
      dispatch(
        showToastAction({
          type: "error",
        })
      );
    } finally {
      setIsSearch(false);
    }
  };

export const updateContractAction =
  (id, payload, setLoading, onRes) => async (dispatch) => {
    setLoading(true);

    try {
      const res = await putApi(endPoints.CREATE_CONTRACT + `/${id}`, payload);

      if (res.success) {
        const responseData = {
          ...res.data,
        };
        dispatch(showToastAction({ type: "success", detail: res?.message }));

        // Call the onRes callback with the response data
        if (onRes) {
          onRes({ success: true, data: responseData });
        }
      } else {
        dispatch(showToastAction({ type: "error", detail: res?.message }));
      }
    } catch (error) {
      console.error("Error updating contract:", error);
      dispatch(
        showToastAction({
          type: "error",
          detail: "An unexpected error occurred while updating contract.",
        })
      );
    } finally {
      setLoading(false);
    }
  };

export const signContractAction =
  (id, payload, setLoading, dispatch, onRes) => async () => {
    setLoading(true);

    try {
      const { role, signature } = payload;
      const res = await postApi(endPoints.SIGN_CONTRACT + `/${id}`, {
        role,
        signature,
      });

      if (res.success) {
        // const responseData = {
        //   ...res.data,
        // };
        // dispatch(showToastAction({ type: "success", detail: res?.message }));

        // Call the onRes callback with the response data
        if (onRes) {
          onRes({ success: true, data: res.data });
        }
      } else {
        dispatch(showToastAction({ type: "error", detail: res?.message }));
      }
    } catch (error) {
      console.error("Error creating contract:", error);
      dispatch(
        showToastAction({
          type: "error",
          detail: "Document need to be signed first",
        })
      );
    } finally {
      // Stop loading regardless of success or failure
      setLoading(false);
    }
  };

export const shareContractAction =
  (payload, setShareLoading, dispatch, onRes) => async () => {
    setShareLoading(true);

    try {
      const res = await postApi(endPoints.SHARE_CONTRACT, payload);

      if (res.success) {
        // const responseData = {
        //   ...res.data,
        // };
        dispatch(showToastAction({ type: "success", detail: res?.message }));

        // Call the onRes callback with the response data
        if (onRes) {
          onRes({ success: true, data: res.data });
        }
      } else {
        dispatch(showToastAction({ type: "error", detail: res?.message }));
      }
    } catch (error) {
      console.error("Error creating contract:", error);
      dispatch(
        showToastAction({
          type: "error",
          detail: "An unexpected error occurred.",
        })
      );
    } finally {
      // Stop loading regardless of success or failure
      setShareLoading(false);
    }
  };

export const updateDocumentAction =
  (id, content, setLoading, onRes) => async (dispatch) => {
    setLoading(true);

    try {
      const res = await putApi(
        endPoints.SAVE_DOCUMENT + `/${id}`,             
        content
      );

      if (res.success) {
        const responseData = {
          ...res.data,
        };
        dispatch(showToastAction({ type: "success", detail: res?.message }));

        // Call the onRes callback with the response data
        if (onRes) {
          onRes({ success: true, data: responseData });
        }
      } else {
        dispatch(showToastAction({ type: "error", detail: res?.message }));
      }
    } catch (error) {
      console.error("Error updating contract:", error);
      dispatch(
        showToastAction({
          type: "error",
          detail: "An unexpected error occurred while updating contract.",
        })
      );
    } finally {
      setLoading(false);
    }
  };
